module.exports = __webpack_public_path__ + "img/36.81d17905.jpg";